import { Box, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, Divider, Grid, Hidden, IconButton, InputAdornment, Paper, Stack, Step, StepLabel, Stepper, Tab, Tabs, TextField, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { CheckBoxIcon, CheckedBoxIcon, CloseLineIcon, DeviceIcon, EnableDeviceIcon, SearchIcon } from '../../components/IconComponent'
import { useTranslation } from 'react-i18next';
import CardComponent from '../../components/Card';
import StepsComponent from './StepsComponent';
import { commonFont } from '../../theme';
import { config } from '../../wsclient/crmservices/config';
export default function InstallationAddDeviceView(props) {
    const { orderDetail, activity, activeStep, subscriptions, devices, showLoadingDevice, showLoadingSubscription, subscriptionSelected, deviceSelected } = props;
    const { t } = useTranslation();
    console.log('InstallationAddDeviceView:', props);
    const steps = [
        {
            id: "ADD_DEVICE",
            label: "Add Device",
            icon: DeviceIcon
        },
        {
            id: "ENABLE_DEVICE",
            label: "Enable Device",
            icon: EnableDeviceIcon
        }
    ];
    const renderStatus = (status) => {
        let label = t(status);
        let color = status == 'COMPLETED' ? 'success' : 'warning'
        return <Chip label={label} variant='customOutlined' size='small' color={color} />
    }
    return (
        <Dialog
            open={props.isOpen}
            onClose={props.onClose}
            fullWidth={true}
            maxWidth={"md"}
            sx={{ '& .MuiDialog-paper': { padding: '0px 0px' } }}
        >
            <Stack width={'100%'} height={60} flexDirection={'row'} justifyContent={'flex-start'} alignItems={'center'} paddingX={2}>
                <IconButton onClick={() => props.onClose()}>
                    <CloseLineIcon />
                </IconButton>
                <Typography variant='subtitle1' marginLeft={1} marginRight={1}>Order {orderDetail.number}</Typography>
                {renderStatus(orderDetail.state)}
                {orderDetail.stage && <Stack marginLeft={1}><Chip label={orderDetail.stage.name} variant='customOutlined' size='small' /></Stack>}
            </Stack>
            <DialogContent dividers={true}>
                <StepsComponent steps={steps} active={activeStep} isError={props.stepMessage} message={props.stepMessage} stepError={activeStep} />
                <Grid xs={12} item marginTop={4}>
                    {activeStep == 0 && <AddDeviceStep
                        showLoadingSubscription={showLoadingSubscription}
                        showLoadingDevice={showLoadingDevice}
                        subscriptions={subscriptions}
                        devices={devices}
                        subscriptionSelected={subscriptionSelected}
                        deviceSelected={deviceSelected}
                        quantityPG={props.quantityPG}
                        onSelectDevice={props.onSelectDevice}
                        onSelectSubscription={props.onSelectSubscription}
                        onCancelAddDevice={props.onCancelAddDevice}
                        onSubmitAddDevice={props.onSubmitAddDevice}
                    />}

                    {activeStep == 1 && <EnableDeviceStep
                        subscriptions={subscriptions}
                        subscriptionSelected={subscriptionSelected}
                        showLoadingService={props.showLoadingService}
                        showLoadingServiceDevice={props.showLoadingServiceDevice}
                        services={props.services}
                        serviceDevices={props.serviceDevices}
                        serviceSelected={props.serviceSelected}
                        serviceDeviceSelected={props.serviceDeviceSelected}
                        onSelectService={props.onSelectService}
                        onSelectDeviceService={props.onSelectDeviceService}
                        onSelectServiceRow={props.onSelectServiceRow}
                        onSelectSubscription={props.onSelectSubscription}
                    />}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid xs={12} item container direction={'row'} paddingX={2} paddingY={1} justifyContent={'center'}>
                    {activeStep == 0 && <Button disabled={deviceSelected.length == 0} sx={{ marginRight: 2 }} variant='contained' onClick={() => props.onSubmitAddDevice()}>{t('btn_submit')}</Button>}
                    {activeStep == 1 && <Button sx={{ marginRight: 2 }} variant='contained' onClick={() => props.onSubmitEnableService()}>{t('btn_submit')}</Button>}
                    <Button variant='contained' color='grey' onClick={() => props.onCancelAddDevice()}>{t('btn_close')}</Button>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

function AddDeviceStep(props) {
    const { palette, shadows } = useTheme();
    const [devices, setDevices] = useState([]);
    const [searchValue, setSearchValue] = useState();
    const [tabIndex, setTabIndex] = useState(0);
    const { quantityPG, subscriptionSelected, deviceSelected, subscriptions, showLoadingDevice, showLoadingSubscription, onSelectDevice, onSelectSubscription } = props;

    useEffect(() => {
        if (props.devices) {
            setDevices(props.devices)
        }
    }, [props.devices])

    const renderStatus = (state) => {
        let color = '';
        if (state == 'ACTIVE') {
            color = 'success'
        } else if (state == 'DRAFT') {
            color = 'warning'
        } else {
            color = 'error'
        }
        return <Chip label={state} variant='customOutlined' size='small' color={color} />
    }

    const onChangeSearch = (event) => {
        let _devices = props.devices;
        let value = event.target.value;
        if (value) {
            _devices = props.devices.filter(d => {
                return d.serial_number.includes(value);
            })
        }
        setSearchValue(value);
        setDevices(_devices);
    }

    const onChangeTab = (event, newValue) => {
        console.log("AAAA index:", newValue);
        setTabIndex(newValue)
        props.onSelectSubscription(subscriptions[newValue]);
    }
    return (
        <>
            <Hidden mdDown>
                <Stack flex={1} direction={'row'} spacing={2}>
                    <Stack flex={1}>
                        <CardComponent paddingX={2} paddingY={2}>
                            <Typography marginBottom={1} variant={'body1'}>{"Subscriptions"}</Typography>
                            <Divider />
                            {showLoadingSubscription && <Stack marginY={0.5} flex={1} justifyContent={'center'} alignItems={'center'}><CircularProgress /> </Stack>}
                            <Stack flex={1}
                                sx={{
                                    height: 300,
                                    overflowY: 'scroll',
                                    marginTop: 0.5
                                }}
                            >
                                {subscriptions.map((item, index) => {
                                    let billingPeriod = item.terms.billing_period ? item.terms.billing_period.duration + " " + item.terms.billing_period.uot : "";
                                    return (
                                        <Stack key={index} flex={1} direction={'row'} paddingY={1} borderBottom={subscriptions.length - 1 > index ? 1 : undefined} borderColor={palette.border.main}>
                                            <Stack flex={2} direction={'row'} alignItems={'flex-start'}>
                                                {renderStatus(item.state)}
                                                <Stack marginLeft={1}>
                                                    <Typography variant={'subtitle2'}>{billingPeriod}</Typography>
                                                    <Typography variant={'subtitle2'}>{item.code}</Typography>
                                                </Stack>

                                            </Stack>
                                            <Stack flex={1} alignItems={'flex-end'}>
                                                <Stack onClick={() => onSelectSubscription(item)}>
                                                    {subscriptionSelected && subscriptionSelected.id == item.id ? <CheckedBoxIcon /> : <CheckBoxIcon />}
                                                </Stack>
                                            </Stack>
                                        </Stack>

                                    )
                                })}
                            </Stack>
                        </CardComponent>
                    </Stack>
                    <Stack flex={1}>
                        <CardComponent paddingX={2} paddingY={2}>
                            <Stack flex={1} direction={'row'}>
                                <Stack flex={1}>
                                    <Typography marginBottom={1} variant={'body1'}>{"Devices"}</Typography>
                                </Stack>
                                {/* <Stack flex={1} justifyContent={'flex-end'} direction={'row'}>
                            <Typography marginBottom={1} variant={'subtitle1'}>{deviceSelected ? deviceSelected.length : 0}/</Typography>
                            <Typography color={'error'} marginBottom={1} variant={'body1'}>{quantityPG}</Typography>
                        </Stack> */}
                            </Stack>
                            <Divider />
                            <Stack marginY={1} flex={1}>
                                <TextField
                                    variant='outlined'
                                    value={searchValue}
                                    placeholder={"Enter serial number"}
                                    onChange={onChangeSearch}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    }}
                                />
                            </Stack>
                            {showLoadingDevice && <Stack marginY={0.5} flex={1} justifyContent={'center'} alignItems={'center'}><CircularProgress /> </Stack>}
                            <Stack flex={1}
                                sx={{
                                    height: 300,
                                    overflowY: 'scroll',
                                }}
                            >
                                {devices.map((device, index) => {
                                    // console.log('device:',device);
                                    let _devicesSelected = deviceSelected.filter(d => {
                                        return d.id == device.id;
                                    })
                                    let isSelected = _devicesSelected && _devicesSelected.length > 0 ? true : false;
                                    return (
                                        <DeviceItem
                                            key={index}
                                            borderBottom={devices.length - 1 > index ? 1 : undefined}
                                            isSelected={isSelected}
                                            device={device}
                                            onClick={onSelectDevice}
                                        />
                                    )
                                })}
                            </Stack>
                        </CardComponent>
                    </Stack>
                </Stack>
            </Hidden>
            <Hidden mdUp>
                <Tabs
                    value={tabIndex}
                    onChange={onChangeTab}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs categories"
                    sx={{ '& .MuiTabs-indicator': { display: 'none' }, '& .MuiTabs-flexContainer': { paddingBottom: 2, paddingX: 2 } }}
                >
                    {subscriptions.map((item, index) => {
                        let billingPeriod = item.terms.billing_period ? item.terms.billing_period.duration + " " + item.terms.billing_period.uot : "";
                        return (
                            <Tab key={index} label={billingPeriod}
                                sx={{
                                    marginRight: 2,
                                    minHeight: 32,
                                    borderRadius: 1,
                                    height: 36,
                                    border: 'none',
                                    boxShadow: index == tabIndex ? shadows[1] : undefined,
                                    fontWeight: index == tabIndex ? 'bold' : 'medium',
                                    transition: 'all 0.3s ease 0s',
                                }}
                            />
                        )
                    })}
                </Tabs>
                <Grid xs={12} item component={Paper} paddingY={2} paddingX={2}>
                    <Stack flex={1} direction={'row'}>
                        <Stack flex={1}>
                            <Typography marginBottom={1} variant={'body1'}>{"Devices"}</Typography>
                        </Stack>
                        {/* <Stack flex={1} justifyContent={'flex-end'} direction={'row'}>
                            <Typography marginBottom={1} variant={'subtitle1'}>{deviceSelected ? deviceSelected.length : 0}/</Typography>
                            <Typography color={'error'} marginBottom={1} variant={'body1'}>{quantityPG}</Typography>
                        </Stack> */}
                    </Stack>
                    <Divider />
                    <Stack marginY={1} flex={1}>
                        <TextField
                            variant='outlined'
                            value={searchValue}
                            placeholder={"Enter serial number"}
                            onChange={onChangeSearch}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            }}
                        />
                    </Stack>
                    {showLoadingDevice && <Stack marginY={0.5} flex={1} justifyContent={'center'} alignItems={'center'}><CircularProgress /> </Stack>}
                    <Stack flex={1}
                        sx={{
                            height: 300,
                            overflowY: 'scroll',
                        }}
                    >
                        {devices.map((device, index) => {
                            let _devicesSelected = deviceSelected.filter(d => {
                                return d.id == device.id;
                            })
                            let isSelected = _devicesSelected && _devicesSelected.length > 0 ? true : false;
                            return (
                                <DeviceItem
                                    key={index}
                                    borderBottom={devices.length - 1 > index ? 1 : undefined}
                                    isSelected={isSelected}
                                    device={device}
                                    onClick={onSelectDevice}
                                />
                            )
                        })}
                    </Stack>
                </Grid>
            </Hidden>
        </>
    )
}


function EnableDeviceStep(props) {
    const [tabIndex, setTabIndex] = useState(0);
    const { palette, shadows } = useTheme();
    const { subscriptions, subscriptionSelected, showLoadingService, services, serviceDevices, serviceSelected, onSelectDeviceService, onSelectService, serviceDeviceSelected } = props;
    console.log('serviceDevices:', serviceDevices);
    console.log('services:', services);

    const renderStatus = (state) => {
        let color = '';
        if (state == 'EFFECTIVE') {
            color = 'success'
        } else if (state == 'DRAFT') {
            color = 'warning'
        } else {
            color = 'error'
        }
        return <Chip label={state} variant='customOutlined' size='small' color={color} />
    }

    const onChangeTab = (event, newValue) => {
        console.log("AAAA index:", newValue);
        setTabIndex(newValue)
        props.onSelectSubscription(subscriptions[newValue]);
    }
    console.log("serviceSelected:", serviceSelected);
    return (
        <Stack flex={1} >
            <Stack flex={1}>
                <Tabs
                    value={tabIndex}
                    onChange={onChangeTab}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs categories"
                    sx={{ '& .MuiTabs-indicator': { display: 'none' }, '& .MuiTabs-flexContainer': { paddingBottom: 2, paddingX: 2 } }}
                >
                    {subscriptions.map((item, index) => {
                        let billingPeriod = item.terms.billing_period ? item.terms.billing_period.duration + " " + item.terms.billing_period.uot : "";
                        return (
                            <Tab key={index} label={billingPeriod}
                                sx={{
                                    marginRight: 2,
                                    minHeight: 32,
                                    borderRadius: 1,
                                    height: 36,
                                    border: 'none',
                                    boxShadow: index == tabIndex ? shadows[1] : undefined,
                                    fontWeight: index == tabIndex ? 'bold' : 'medium',
                                    transition: 'all 0.3s ease 0s',
                                }}
                            />
                        )
                    })}
                </Tabs>
            </Stack>
            <Stack flex={1} component={Paper} paddingX={2} paddingY={2} sx={{ maxHeight: 450 }}>
                <Typography variant={'caption'}>{"Services"}</Typography>
                <Divider />
                <Stack flex={1} sx={{ height: 400 }}>
                    <Stack flex={1} sx={{ height: 400, overflowY: 'scroll' }}>
                        {showLoadingService ? <Stack flex={1} marginTop={2} justifyContent={'center'} alignItems={'center'}><CircularProgress /></Stack> :
                            services.map((service, index) => {
                                return (
                                    <Stack key={index} flex={1} paddingY={2} borderBottom={services.length - 1 > index ? 1 : undefined} borderColor={palette.border.main}>
                                        <Stack flex={1} direction={'row'} spacing={2}>
                                            {renderStatus(service.state)}
                                            <Typography marginTop={1} variant={'body1'}>{service.product.name}</Typography>
                                        </Stack>
                                        {service.devices && service.devices.length > 0 && <Stack flex={1} paddingX={2} marginTop={2}>
                                            {service.devices.map((d, index) => {
                                                let device = d.device;
                                                let _deviceSelected = serviceSelected.filter(s => {
                                                    let existingDevices = s.devices.filter(d => {
                                                        return d.device_id == device.id && s.service_id == service.id
                                                    })
                                                    return existingDevices && existingDevices.length > 0 ? true : false
                                                })
                                                let isSelected = _deviceSelected && _deviceSelected.length > 0 ? true : false;
                                                return (
                                                    <DeviceItem
                                                        state={d.state}
                                                        key={index}
                                                        service={service}
                                                        borderBottom={service.devices.length - 1 > index ? 1 : undefined}
                                                        isSelected={isSelected}
                                                        device={device}
                                                        onClick={onSelectDeviceService}
                                                    />
                                                )
                                            })}
                                        </Stack>}
                                    </Stack>
                                )
                            })
                        }
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    )
}

function DeviceItem(props) {
    const { palette } = useTheme();
    const { isSelected, state, service, device, borderBottom } = props;
    return (
        <Stack width={'100%'} direction={'row'} paddingY={1.5}
            borderBottom={borderBottom} borderColor={palette.border.main}
            alignItems={'center'}
            spacing={2}
            sx={{
                opacity: state == 'ENABLED' ? 0.5 : 1
            }}
        >
            <Stack onClick={() => state=='ENABLED' ? undefined : props.onClick(service, device, isSelected)}>
                {isSelected || state=='ENABLED' ? <CheckedBoxIcon /> : <CheckBoxIcon />}
            </Stack>
            <Stack flex={2} direction={'row'} spacing={2}>
                <Typography variant={'subtitle2'}>{device.serial_number}</Typography>
                <Chip label={device.product.name} variant='customOutlined' size='small' />
            </Stack>
        </Stack>
    )
}
